import React, { useMemo } from 'react'
import styles from './ImageBox.module.sass'
import WImage from '../WImage/WImage'

interface Props {
  conf?: any
  confTablet?: any
  confMobile?: any
  forceHeight?: boolean
  className?: string
  children?: React.ReactNode
}

const ImageBox = (props: Props) => {
  const {
    conf = {},
    confTablet = undefined,
    confMobile = undefined,
    forceHeight = false,
    className = '',
    children = undefined,
  } = props

  const desktopImage = useMemo(
    () =>
      !!conf?.src && (
        <WImage
          {...conf}
          className={`${styles.image} ${styles['image--desktop']} ${conf.className || ''}`}
          style={forceHeight && conf.maxHeight ? { height: `${conf.maxHeight}px` } : undefined}
        />
      ),
    [conf?.src]
  )

  const tabletImage = useMemo(
    () =>
      !!confTablet?.src && (
        <WImage
          {...{ ...(conf || {}), ...confTablet }}
          className={`${styles.image} ${styles['image--tablet']} ${conf.className || ''}`}
          style={
            forceHeight && conf.maxHeight ? { height: `${confTablet.maxHeight}px` } : undefined
          }
        />
      ),
    [confTablet?.src]
  )

  const mobileImage = useMemo(
    () =>
      !!confMobile?.src && (
        <WImage
          {...{
            ...(conf || {}),
            ...(confTablet || {}),
            ...confMobile,
          }}
          className={`${styles.image} ${styles['image--mobile']} ${conf.className || ''}`}
          style={
            forceHeight && conf.maxHeight ? { height: `${confMobile.maxHeight}px` } : undefined
          }
        />
      ),
    [confMobile?.src]
  )

  return (
    <div
      className={`${styles.root} 
      ${!conf?.src ? 'imageBox--no-image-desktop' : ''} 
      ${!confTablet?.src ? 'imageBox--no-image-tablet' : ''} 
      ${!confMobile?.src ? 'imageBox--no-image-mobile' : ''} 
    ${className}`}
    >
      {!!conf.src && desktopImage}
      {!!confTablet?.src && tabletImage}
      {!!confMobile?.src && mobileImage}
      {children}
    </div>
  )
}

export default ImageBox
